<template>
  <div :class="{User:isLeft,Users:!isLeft}">
    <el-popover trigger="hover">
<!--      <div class="UserMenu cursor" @click="reload()">重新授权</div>-->
      <div class="UserMenu cursor" @click="updatePwd">修改密码</div>
      <div class="UserMenu cursor" @click="reload()">退出登录</div>
      <template  #reference>
        <div class="UserShow">
          <div class="UserImage"><img :src="userImage" alt="" srcset=""> </div>
          <div class="UserName">{{userName}}</div>
        </div>
      </template>
    </el-popover>
    <updatePwd ref="updatePwd"  ></updatePwd>
  </div>
</template>
<script >
import {currentuser} from "@/utils/api";
import {getFullUrl} from "../../public/js/index.js";
import updatePwd from "@/components/updatePwd.vue"
import {ElPopover} from "element-plus";
export default {
  name: 'UserAndImage',
  components: {
    ElPopover,updatePwd
  },
  data() {
    return {
      userImage:'./default.png',
      userName:'测试用户昵称',
      isShow:false
    };
  },
  props:{
    isLeft:{
      default: true,
      type: Boolean,
    }
  },
  computed: {

  },
  beforeMount() {
    this.getCurrentUser()
  },
  methods:{
    async  getCurrentUser (){
      currentuser().then(res=>{
        const user_data = res.Data;
        this.userImage =user_data.userImage ? getFullUrl(user_data.userImage)  : getFullUrl('./default.png' );
        this.userName = user_data.username;
      }).catch(err=>{
        console.log(err)
      })
    },
    updatePwd(){
      this.$refs.updatePwd.open()
    },
    reload(){
      localStorage.removeItem('token')
      this.$router.push("/login");
    }
  }
};
</script>
<style scoped>
.User{
  position: fixed;
  margin-right: 50px;
  right: 60px;
  top:20px;
  z-index: 999;
}
.Users{
  position: fixed;
  margin-right: -20px;
  right: 60px;
  top:20px;
  z-index: 999;
}
.UserShow{
  display: flex;
  justify-content: space-between;
  align-items: center;

}
.UserImage{
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
}
.UserImage img{
  width: 100%;
  height: 100%;
}
.UserName{
  margin-left: 10px;
  color: #303133;
  font-size: 12px;
  font-weight: 600;
}
.UserMenu{
  background-color: #ffffff;
  width: 100%;
  text-align: center;
  border-radius: 5px;
  font-size: 14px;
}
</style>